export default __webpack_public_path__ + "static/Adelle-Regular-1e51b60eb0c215be5b5b605f0c4883b8.woff2";